export default {
  headers: {
    edit_time: 'Muokkaa aikaa',
    create_time: 'Luo aika',
  },
  labels: {
    select_all: 'Valitse kaikki',
  },
  buttons: {
    add_opening_time: 'Lisää aukioloaika',
    add: 'Lisää',
    cancel: 'Peruuta',
  },
};
